import React from 'react';

import { SvgIcon } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

type IconStyles = {
  height: number;
  right: number;
  width: number;
};

interface ArrowDownIconProps {
  iconStyles: IconStyles;
}

const useStyles = makeStyles<IconStyles>()((_theme, { height, right, width }) => ({
  svg: {
    height,
    pointerEvents: 'none',
    position: 'absolute',
    right,
    width,
  },
}));

export function ArrowDownIcon(props: ArrowDownIconProps): JSX.Element {
  const { classes } = useStyles(props.iconStyles);
  return (
    <SvgIcon className={classes.svg} viewBox="0 0 12 12">
      <path d="M9.328 4.635a.75.75 0 1 1 1.036 1.085L6.846 9.08a1.002 1.002 0 0 1-1.384 0L1.944 5.72a.75.75 0 0 1 1.035-1.085l3.175 3.031 3.174-3.03z" />
    </SvgIcon>
  );
}
